/**
 * WHICH issue sources a viewer sees — the single home for the role
 * branch shared by `SupportScreen` (which narrows the REQUEST, not
 * the response) and `TopBarStats` (whose Issues badge must count the
 * same set of rows the viewer's Support screen shows — a badge that
 * counts rows the operator cannot see anywhere reads as a stuck
 * number, which is exactly the defect this replaced).
 *
 * Extracted from `SupportScreen.tsx` so the badge cannot drift from
 * the screen by duplicating the role list.
 */

/** Roles that see the platform-internal columns (severity, source)
 *  and the source filter. Mirrors the support console's own audience
 *  — see `apps/support-console/src/App.tsx`'s `CONSOLE_ROLES`. */
export const INTERNAL_VIEW_ROLES: readonly string[] = [
  'nexsoss:platform_admin',
  'nexsoss:support_l2',
  'nexsoss:support_l3',
];

export function canSeeInternalIssues(roles: readonly string[]): boolean {
  return roles.some((r) => INTERNAL_VIEW_ROLES.includes(r));
}

/**
 * The issue-source set the viewer's Support screen shows by default:
 * internal roles see every source (`undefined` = no filter), ordinary
 * operators are pinned to `task`. Note the issues SUMMARY endpoint
 * excludes the `device` source server-side either way (device
 * problems are Alert rows, counted under the Alerts badge).
 */
export function visibleIssueSources(roles: readonly string[]): readonly string[] | undefined {
  return canSeeInternalIssues(roles) ? undefined : ['task'];
}
